import axios from 'axios'
import store from '@/store'
import router from '@/router'

const apiClient = axios.create({
    baseURL: process.env.NODE_ENV === 'production'
        ? 'https://dashboard.eaglesvisionbusiness.com/api'
        : (process.env.VUE_APP_API_URL || 'https://evt-admin.test/api'),
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
})

// Interceptor to add auth token
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Interceptor to handle 401 errors (expired/invalid token)
let isLoggingOut = false
let logoutPromise = null

apiClient.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        // Ignore 401 errors from logout endpoint (token already invalid)
        const isLogoutRequest = error.config && error.config.url && error.config.url.includes('/auth/logout')

        if (error.response && error.response.status === 401 && !isLogoutRequest) {
            // Token is invalid or expired

            // If logout is already in progress, wait for the existing promise
            if (isLoggingOut) {
                console.log('⏳ Logout already in progress, waiting...')
                if (logoutPromise) {
                    return logoutPromise.then(() => Promise.reject(error))
                }
                return Promise.reject(error)
            }

            console.log('🔒 Session expired - logging out user')

            // Set flag IMMEDIATELY (synchronous)
            isLoggingOut = true

            // Create logout promise
            logoutPromise = store.dispatch('auth/logout')
                .catch(() => { })
                .finally(() => {
                    // Redirect to home page
                    if (router.currentRoute.path !== '/') {
                        router.push('/').catch(() => { })
                    }

                    // Reset flags after a small delay to ensure state updates
                    setTimeout(() => {
                        isLoggingOut = false
                        logoutPromise = null
                    }, 200)
                })

            // Return the logout promise
            return logoutPromise.then(() => Promise.reject(error))
        }
        return Promise.reject(error)
    }
)

export default apiClient
